import _ from 'lodash';
import dialog from '@/scripts/tools/dialog';
import { tips } from '@/scripts/tools/utils';
import keyBox from '@/scripts/helper/keyBox';
import { regions } from '@/scripts/tools/config';

export default {
  data() {
    return {
      regionMap: {},
      sessionMap: {},
      list: [],
      visibleRows: [],
      credential: null,
    };
  },
  mounted() {
    this.getRemoteConfig();
    this.updateList();
  },
  methods: {
    getRemoteConfig() {
      const language = this.$store.localeLanguage;
      regions.forEach(item => {
        const { region } = item;
        const labelLan = `label_${language}`;
        const label = item[labelLan];
        this.regionMap[region] = label;
      });
    },
    updateList() {
      this.list = keyBox.getSessionList().map(v => {
        const { SecretId } = v;
        this.sessionMap[SecretId] = true;
        v.simpleSecretId = `${SecretId.substr(0, 4)}......${SecretId.substr(-8)}`;
        return v;
      });
    },
    // 添加快速访问路径
    addPath(info) {
      info.AccessPath = info.AccessPath.replace(/\/*$/, '/')
        .replace(/^\/+/, '')
        .replace(/\/{2,}/, '/');

      const { Contents } = this.credential;
      if (Contents[info.AccessPath]) {
        tips.error(this.$t('error.quick_access_path_exist'));
        return;
      }

      const item = _.cloneDeep({ ...this.credential, ...info });
      delete item.Contents;
      delete item.edit;
      delete item.simpleSecretId;
      keyBox.addKey(item);
      this.updateList();
    },
    // 编辑快速访问路径
    editPath(info) {
      info.AccessPath = info.AccessPath.replace(/\/*$/, '/')
        .replace(/^\/+/, '')
        .replace(/\/{2,}/, '/');
      const { SecretId, AccessPath } = this.credential;
      keyBox.removeAccessPath(SecretId, AccessPath);

      const Contents = keyBox.getSessionContents(SecretId);
      if (Contents[info.AccessPath]) {
        tips.error(this.$t('error.quick_access_path_exist'));
        return;
      }

      const item = _.cloneDeep({ ...this.credential, ...info });
      keyBox.addKey(item);
      this.updateList();
    },
    resetCredential() {
      this.credential = null;
    },
    // 使用会话
    useSession(item) {
      const credential = _.cloneDeep(item);
      delete credential.Contents;
      delete credential.simpleSecretId;
      // credential.AccessPath = '';
      // credential.Region = '';
      keyBox.setLastSession(credential);
    },
    handleCreateOrEditSession({ form, type }) {
      if (type === 'edit') {
        this.editSession(form);
      } else {
        this.createSession(form);
      }
    },
    // 编辑会话
    editSession(item) {
      tips.success(this.$t('core.success', { msg: this.$t('core.edit') }));
      keyBox.addKey({ ...item, Remember: true });
      this.updateList();
    },
    createSession(item) {
      if (this.sessionMap[item.SecretId]) {
        tips.error(this.$t('error.session_exist'));
        return;
      }

      tips.success(this.$t('core.success', { msg: this.$t('core.create') }));
      keyBox.addKey({ ...item, Remember: true });
      this.updateList();
    },
    // 删除 会话/ 快速访问路径
    deleteSession(item) {
      const message = item.Contents
        ? this.$t('cos.confirm.delete_session[0]', { name: item.SecretId })
        : this.$t('cos.confirm.delete_session[1]', {
          name: item.SecretId,
          path: item.AccessPath || this.$t('core.root'),
        });
      dialog.confirm({ message, icon: 'error', title: this.$t('cos.delete_session') }, confirm => {
        if (confirm) {
          if (item.Contents) delete this.sessionMap[item.SecretId];
          keyBox.removeKey(item);
          this.updateList();
        }
      });
    },
  },
};
